import React from 'react';

import { HeaderIcons } from '@/components/common';

import './DashboardHeader.css';

interface DashboardHeaderProps {
  title: string | React.ReactNode;
  tab: string;
  showIcons?: boolean;
}

const DashboardHeader: React.FC<DashboardHeaderProps> = ({
  title,
  tab,
  showIcons = true
}) => {
  return (
    <div className="dashboard-header">
      <h1 className="dashboard-header__title">{title}</h1>
      {showIcons && <HeaderIcons tab={tab} />}
    </div>
  );
};

export default DashboardHeader;
